
export const coursedata=[
    {
        id:1,
        courseimg:"https://res.cloudinary.com/codercloud/image/upload/v1662458672/download_1_wqnwxr.jpg",
        coursetype:"Business",
        coursetitle:"Ultimate Business Intelligence Analyst A to Z Course 2021",
        registeredstudents:4516,
        totallectures:44,
        teacher:"Albert Hitler",
        newprice:4500,
        oldprice:5000
    },
    {
        id:2,
        courseimg:"https://res.cloudinary.com/codercloud/image/upload/v1662458688/how-to-make-money-as-a-graphic-designer_jfiw3a.webp",
        coursetype:"Design",
        coursetitle:"Adobe Photoshop Training: From Beginner to Pro",
        registeredstudents:6565,
        totallectures:50,
        teacher:"Robert John",
        newprice:6000,
        oldprice:7000
    },
    {
        id:3,
        courseimg:"https://res.cloudinary.com/codercloud/image/upload/v1662458672/download_sy0eqv.jpg",
        coursetype:"Marketing",
        coursetitle:"Social Media Marketing - A to Z Content Marketing class 2021",
        registeredstudents:4800,
        totallectures:30,
        teacher:"Siam Jane",
        newprice:500,
        oldprice:1000
    }
]